import React from "react";
import { useContentInfo } from "../contexts/ContentContext";

function Gallery() {
  const { contentInfo } = useContentInfo();

  return (
    <section className="gallery" data-aos="fade-up">
      <img src={contentInfo?.ads?.ad1URL} alt="Pharmacy gallery 1" />
      <img src={contentInfo?.ads?.ad2URL} alt="Pharmacy gallery 2" />
    </section>
  );
}

export default Gallery;
